module.exports = __webpack_public_path__ + "static/media/insol-card.21802297.png";